export default __webpack_public_path__ + "static/media/about-vission.5df097fb.png";